import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters as CartPageQueryParams } from "@faire/web-api--source/routes/cart";
export var useCartPageSearchQuery = function() {
    var query = useQueryParams(CartPageQueryParams.parse).query;
    return query;
};
